import RELAXEGAMEActions from './RELAXEGAMEActions'

export default class RELAXTABLEActions extends RELAXEGAMEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'RELAX',
      gameType: 'TABLE',
      gameCode: 'RELAX-TABLE-001',
    }

    this.gameName = 'Blackjack Neo'
  }
}
